import axios from "../lib/axios";
import { API_WEB } from "../utils/constants";

const csrf = () => axios.get("/sanctum/csrf-cookie");

export async function getLectureContent({
  courseId,
  lectureId,
  apiOperations: { filter, sortBy, include, includeFields, page = 1, perPage = 10 },
}) {
  await csrf();

  // Base API Query
  let query = `${API_WEB}/courses/${courseId}/lectures/${lectureId}/items`;

  //Filter
  if (Array.isArray(filter)) {
    let filterQuery = "";

    filter.forEach((el, index) => {
      filterQuery += `${index !== 0 ? "&" : ""}filter[${el.field}]=${el.value}`;
    });

    query += `${query.includes("?") ? "&" : "?"}${filterQuery}`;
  } else if (filter) {
    // Check if filter is a single object
    let filterQuery = `filter[${filter.field}]=${filter.value}`;

    query += `${query.includes("?") ? "&" : "?"}${filterQuery}`;
  }

  // Sorting
  if (Array.isArray(sortBy)) {
    let sortQuery = "";

    sortBy.forEach((el, index) => {
      const direction = el.direction === "asc" ? "" : "-";
      sortQuery += `${index !== 0 ? "," : ""}${direction}${el.field}`;
    });

    query += `${query.includes("?") ? "&" : "?"}sort=${sortQuery}`;
  } else if (sortBy) {
    let sortQuery = `${sortBy.direction === "asc" ? "" : "-"}${sortBy.field}`;

    query += `${query.includes("?") ? "&" : "?"}sort=${sortQuery}`;
  }

  // Include
  if (Array.isArray(include)) {
    let includeQuery = "";

    include.forEach((el, index) => {
      includeQuery += `${index !== 0 ? "&" : ""}include${el.field}=${el.field}`;
    });

    query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
  } else if (include) {
    let includeQuery = `include${include.field}=${include.value}`;

    query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
  }

  //includeFields
  if (Array.isArray(includeFields)) {
    let includeQuery = "include=";

    includeFields.forEach((el, index) => {
      includeQuery += `${index !== 0 ? "," : ""}${el}`;
    });

    query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
  } else if (includeFields) {
    let includeQuery = `include=${includeFields}`;

    query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
  }

  //Pagination
  if (page !== 0 && page >= 1) {
    query += `${query.includes("?") ? "&" : "?"}page=${page}${
      perPage ? "&perPage=" : ""
    }${perPage}`;
  }

  //Feaching The Data before adding all operations
  const response = await axios.get(query);

  if (response.status !== 200) {
    throw new Error(response.response.data.message);
  }

  return response.data;
}

export async function getVideoInformation({ courseId, lectureId, videoId }) {
  await csrf();

  // Base API Query
  const query = `${API_WEB}/courses/${courseId}/lectures/${lectureId}/items/${videoId}/video?includeMyViews=true&includeMyMaxViews=true`;

  //Feaching The Data before adding all operations
  const response = await axios.get(query);

  if (response.status !== 200) {
    throw new Error(response.response.data.message);
  }

  return response.data;
}

export async function getLectureMaterials({
  courseId,
  lectureId,
  apiOperations: { page = 1, perPage = 5 },
}) {
  await csrf();

  // Base API Query
  let query = `${API_WEB}/courses/${courseId}/lectures/${lectureId}/materials`;

  //Pagination
  if (page !== 0 && page >= 1) {
    query += `${query.includes("?") ? "&" : "?"}page=${page}${
      perPage ? "&perPage=" : ""
    }${perPage}`;
  }

  //Feaching The Data before adding all operations
  const response = await axios.get(query);

  if (response.status !== 200) {
    throw new Error(response.response.data.message);
  }

  return response.data;
}

export async function getMaterialFile({ courseId, lectureId, materialId }) {
  await csrf();

  const response = await axios.get(
    `${API_WEB}/courses/${courseId}/lectures/${lectureId}/materials/${materialId}/file`,
    {
      responseType: "blob",
    }
  );

  if (response.status !== 200) {
    throw new Error(response.response.data.message);
  }

  return response.data;
}
